module.exports = __webpack_public_path__ + "img/img-footer-powered@2x.055f4cab.png";